// import axios, { AxiosResponse } from 'axios';
import axios from 'axios'

const client = axios.create({
  // GET/POSTを明示しなかったときにどちらが使用されるか
  method: 'post',

  baseURL: '/srv_app/api',

  // HTTP ヘッダー
  headers: {
    Accept: 'application/json',
    'Content-Type': 'multipart/form-data',
    'Cache-Control': 'no-cache',
  },

  // リクエスト時の共通の前処理
  transformRequest: [
    /** フロント用のページネーションデータをAPI用に変換 */
    data => {
      const pagination = data?.search?.pagination
      if (pagination) {
        data.search.page = {
          sortCollumn:
            pagination.sortBy !== null ? `${pagination.sortBy} ${pagination.descending ? 'desc' : 'asc'}` : null,
          listMax: pagination.rowsPerPage,
          pageNum: (pagination.page - 1) * pagination.rowsPerPage,
        }
        delete data.search.pagination
      }
      return data
    },
    /** オブジェクト形式のデータをFormDataに変換する変換器 */
    data => {
      if (data) {
        // data があるとき
        const formData = new FormData()

        Object.entries(data).forEach(([key, value]) => {
          if (value instanceof Array) {
            for (const file of value) {
              formData.append(key, file)
            }
          } else {
            formData.append(
              key,
              // number型(InfinityとNaNを除く)のときは文字列に変換
              // string型のときはそのまま
              // Blob型またはFile型のときはそのまま
              // それ以外(配列やオブジェクトも含む)はJSON文字列に変換
              typeof value === 'number' && !Number.isFinite(value) && !Number.isNaN(value)
                ? String(value)
                : typeof value === 'string' || value instanceof Blob
                ? value
                : JSON.stringify(value),
            )
          }
        })

        // FormData を返す
        return formData
      } else {
        // data がないとき (null や undefined を想定)
        return data
      }
    },
  ],

  // レスポンス時の共通の前処理
  transformResponse: [
    /** サーバーから返されたstatusによって処理を分岐します */
    data => {
      const json = (() => {
        try {
          // dataをJSONに変換
          return JSON.parse(data)
        } catch {
          // dataがJSON文字列でなかった場合のエラー
          return '何らかのエラーが発生しました'
        }
      })()

      // data の形式
      // {
      //   data: T
      //   message: string
      //   status: 'success' | 'error'
      //   update: string
      //   updatestamp: string
      // }

      if (json.status === 'success') {
        // status が success の場合
        return json.data
      } else if (json.status === 'error') {
        // status が error の場合
        throw json.message
      } else {
        // status が success や error でない場合
        throw '何らかのエラーが発生しました'
      }
    },
    /** API用のページネーションデータをフロント用に変換 */
    data => {
      const pageAttr = data?.pageAttr
      if (pageAttr) {
        data.pagination = {
          page: Math.ceil(pageAttr.currentNum / pageAttr.listMax) + 1,
          rowsNumber: pageAttr.totalCount,
        }
        delete data.pageAttr
      }
      return data
    },
  ],
})

client.interceptors.response.use(
  response => response,
  error => {
    if (error?.message === 'Network Error') {
      // ネットワークエラーの場合
      throw '通信エラーが発生しました。再度お試しください'
    } else if (/^timeout of \d+ms exceeded$/.test(error?.message)) {
      // タイムアウトエラーの場合
      throw '通信エラーが発生しました。再度お試しください'
    } else if (error instanceof Error) {
      // エラーオブジェクトの場合
      throw error.message
    } else {
      // その他のエラーの場合
      throw error
    }
  },
)

export default client
